import { stringifyQs } from "@dashboard/utils/urls";

export const atticApiUsageSectionUrlName = "/attic/api-usage";

export const atticApiUsagePath = `${atticApiUsageSectionUrlName}/`;

/** The range is the query string, so a view of the last 90 days is a link. */
export interface AtticApiUsageUrlQueryParams {
  /** 7, 30 or 90; anything else reads as the default. */
  days?: string;
}

export const atticApiUsageUrl = (params?: AtticApiUsageUrlQueryParams) =>
  atticApiUsagePath + "?" + stringifyQs(params);
